import { BillingPlanTier } from '@core/billing-types';

export const isPp24 = (tier: BillingPlanTier) =>
  [BillingPlanTier.Start, BillingPlanTier.Grow, BillingPlanTier.Optimize].includes(tier);
